import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function MilanooDetails() {
  return (
    <>
      <Header />

      <div className="project-page">
        <div className="project-container">

          {/* Breadcrumb */}
          <div className="project-breadcrumb">
            <Link to="/">Homepage</Link>
            <span>/</span>
            <Link to="/portfolio">Portfolio</Link>
            <span>/</span>
            <span>Milanooo Ice Cream</span>
          </div>

          {/* Title */}
          <div className="project-title-section">
            <h1>
              Milanooo <span>Ice Cream</span>
            </h1>
          </div>

          {/* Read More */}
          <div className="project-readmore">
            <span>Read more</span>

            <a href="#project-content" className="project-arrow">
              ↓
            </a>
          </div>

          {/* Main Content */}
          <div className="project-layout" id="project-content">

            {/* Left Content */}
            <div className="project-sidebar">

              <div className="project-description">

                <h4>Indulgence in Every Scoop</h4>

                <p>
                  Black&White partnered with Milanooo Ice Cream from the ground
                  up, crafting the brand's name, identity, packaging, story,
                  and philosophy.
                </p>

                <p>
                  Designed as more than just a dessert label, Milanooo was
                  positioned as a joyful premium indulgence. The logo and visual
                  language balance elegance with playfulness, reflecting the
                  smooth richness of the product.
                </p>

                <p>
                  A cohesive packaging system and comprehensive brand guidelines
                  ensure strong shelf presence, emotional connection, and
                  consistency across retail, marketing, and digital touchpoints.
                </p>

                <a href="/" className="visit-link">
                  Visit Website →
                </a>

              </div>

            </div>

            {/* Right Images */}
            <div className="project-content">

              <img
                src="/assets/img/works/2.jpg"
                alt="Milanooo"
                className="project-image"
              />

              <img
                src="/assets/img/works/3.jpg"
                alt="Milanooo"
                className="project-image"
              />

              <img
                src="/assets/img/works/4.jpg"
                alt="Milanooo"
                className="project-image"
              />

              <img
                src="/assets/img/works/5.jpg"
                alt="Milanooo"
                className="project-image"
              />

              <img
                src="/assets/img/works/6.jpg"
                alt="Milanooo"
                className="project-image"
              />

            </div>

          </div>

          {/* Pagination */}
          <section className="mil-pagination-frame">
            <div className="mil-pagination">

              <a href="#!" className="mil-pag-link">
                <span className="mil-arrow">←</span>
                <span>Prev project</span>
              </a>

              <Link to="/portfolio" className="mil-all-projects">
                All projects
              </Link>

              <a href="#!" className="mil-pag-link">
                <span>Next project</span>
                <span className="mil-arrow">→</span>
              </a>

            </div>
          </section>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default MilanooDetails;